// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3sBHp","right":"Footer_right__FiMAq","buttons":"Footer_buttons__1zynH"};